import { render, staticRenderFns } from "./cmp-page-title.vue?vue&type=template&id=5a36a366&scoped=true"
import script from "./cmp-page-title.vue?vue&type=script&lang=js"
export * from "./cmp-page-title.vue?vue&type=script&lang=js"
import style0 from "./cmp-page-title.vue?vue&type=style&index=0&id=5a36a366&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a36a366",
  null
  
)

export default component.exports